import React from 'react'
import { GetBaseUrl } from './getBaseUrl';
import { useNavigate } from 'react-router-dom';

function RedirectHelp() {
  const navigate = useNavigate()

    const getHelp = () => {
        let url = GetBaseUrl(window.location.href);
        // window.location.replace(url + "/application/help");
        navigate("/application/help");

      };
  return (
    <div className="redirect-help">
        <span className="md-desc">
          In case of any question you can view our
          <span className="md-desc" onClick={() => getHelp()}>
            Help Page
          </span>
        </span>
      </div>
  )
}

export default RedirectHelp
